/* eslint-disable no-underscore-dangle */
/* eslint-disable react/no-unknown-property */
/* eslint-disable no-useless-escape */
/* eslint-disable no-use-before-define */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-unused-vars */
import { useState, useEffect, useCallback, useRef } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Card,
  CardHeader,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Link,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  Avatar,
  Divider,
  InputAdornment,
  IconButton
} from '@material-ui/core';
import { motion } from 'framer-motion';
import EuroRoundedIcon from '@mui/icons-material/EuroRounded';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';
import EventAvailableRoundedIcon from '@mui/icons-material/EventAvailableRounded';
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { MobileDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import 'dayjs/locale/fr';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { DataGrid } from '@material-ui/data-grid';
import { sessionApi } from '../../../api/sessionApi';
import { formationApi } from '../../../api/formationApi';
import * as moment from 'moment';
import toast from 'react-hot-toast';
import useMounted from '../../../hooks/useMounted';
import { styled } from '@mui/material/styles';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import useAuth from '../../../hooks/useAuth';
import * as XLSX from 'xlsx';
import ListIcon from '@material-ui/icons/List';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { logApi } from '../../../api/logApi';
import PDFMerger from 'pdf-merger-js';
import AttestationPDF from '../../AttestationPDF';
import FolderZipIcon from '@mui/icons-material/FolderZip';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import { pdf } from '@react-pdf/renderer';
import SendIcon from '@mui/icons-material/Send';
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
import AdjustOutlinedIcon from '@mui/icons-material/AdjustOutlined';
import UploadOutlinedIcon from '@mui/icons-material/UploadOutlined';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { Alert, Chip, ClickAwayListener } from '@mui/material';
import { customerApi } from '../../../api/customerApi';
import { useTheme } from '@emotion/react';



const LongPressButton = ({ onShortPress, onLongPress, longPressMs = 2000, children, ...props }) => {
  const timerRef = useRef(null);
  const longPressTriggeredRef = useRef(false);
  const [disableRipple, setDisableRipple] = useState(false);

  const clear = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    // Réactive visuellement le ripple pour les interactions suivantes
    setDisableRipple(false);
  };

  const start = () => {
    longPressTriggeredRef.current = false;
    timerRef.current = setTimeout(() => {
      longPressTriggeredRef.current = true;
      setDisableRipple(true);
      onLongPress?.();
    }, longPressMs);
  };

  const handleMouseDown = () => start();
  const handleMouseUp = () => {
    if (!longPressTriggeredRef.current) onShortPress?.();
    clear();
  };
  const handleMouseLeave = () => clear();

  const handleTouchStart = () => start();
  const handleTouchEnd = () => {
    if (!longPressTriggeredRef.current) onShortPress?.();
    clear();
  };

  return (
    <Box
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseLeave}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      sx={disableRipple ? { '& .MuiTouchRipple-root': { display: 'none !important' } } : undefined}
    >
      {children}
    </Box>
  );
};

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 15,
  borderRadius: 7,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 7,
    backgroundColor: `linear-gradient(90deg, #6fcbb6 ${20}%, #9c64f4 100%)`,
  },
}));

const SessionFacturation = (props) => {
  const { sessionId, session, formation, setShowCheckUserDataAlert, ...other } = props;
  const [rows, setRows] = useState([]);
  moment.locale('fr');
  const mounted = useMounted();
  const navigate = useNavigate();// On utilise navigate afin d'utliser les fonctions de navigation
  const [total, setTotal] = useState(0);
  const { user } = useAuth();
  const [infoFactu, setInfoFactu] = useState({});
  const [honneur, setHonneur] = useState(false);
  const [users, setUsers] = useState([]);
  const [progFactu, setProgFactu] = useState(0);
  const [customers, setCustomers] = useState([]);
  const [alertMessage, setAlertMessage] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [openDialogDelete, setOpenDialogDelete] = useState(false);
  const [openCommonDialog, setOpenCommonDialog] = useState(false);
  const [openTooltip, setOpenTooltip] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentRowLearnerSessionId, setCurrentRowLearnerSessionId] = useState(null);
  const [dialogText, setDialogText] = useState('');
  const [dialogAction, setDialogAction] = useState('');
  const theme = useTheme();
  const [selectedRows, setSelectedRows] = useState([]);
  const [openProgressDialog, setOpenProgressDialog] = useState(false);
  const [progressValue, setProgressValue] = useState(0);
  const [progressText, setProgressText] = useState('');
  const [financiers, setFinanciers] = useState([]);
  const { hostname } = window.location;
  const tenant = hostname.split('.')[0].toUpperCase();

  // States for session profitability
  const [sessionData, setSessionData] = useState(session || {});
  const [openCostDialog, setOpenCostDialog] = useState(false);
  const [costForm, setCostForm] = useState({
    frais_deplacement: 0,
    frais_hebergement: 0,
    frais_salle: 0,
    autres_charges: 0,
    restauration_apprenant: 25,
    livret_apprenant: 6,
    commission_commerciale: 25,
    trainer_rate_day: 1500,
    trainer_days: 1
  });

  useEffect(() => {
    if (session) {
      setSessionData(session);
      setCostForm({
        frais_deplacement: parseFloat(session.frais_deplacement) || 0,
        frais_hebergement: parseFloat(session.frais_hebergement) || 0,
        frais_salle: parseFloat(session.frais_salle) || 0,
        autres_charges: parseFloat(session.autres_charges) || 0,
        restauration_apprenant: session.restauration_apprenant !== null && session.restauration_apprenant !== undefined ? parseFloat(session.restauration_apprenant) : 25,
        livret_apprenant: session.livret_apprenant !== null && session.livret_apprenant !== undefined ? parseFloat(session.livret_apprenant) : 6,
        commission_commerciale: session.commission_commerciale !== null && session.commission_commerciale !== undefined ? parseFloat(session.commission_commerciale) : 25,
        trainer_rate_day: session.trainer_rate_day !== null && session.trainer_rate_day !== undefined ? parseFloat(session.trainer_rate_day) : 1500,
        trainer_days: session.trainer_days !== null && session.trainer_days !== undefined ? parseFloat(session.trainer_days) : 1
      });
    }
  }, [session]);

  const handleOpenCostDialog = () => {
    setCostForm({
      frais_deplacement: parseFloat(sessionData?.frais_deplacement) || 0,
      frais_hebergement: parseFloat(sessionData?.frais_hebergement) || 0,
      frais_salle: parseFloat(sessionData?.frais_salle) || 0,
      autres_charges: parseFloat(sessionData?.autres_charges) || 0,
      restauration_apprenant: sessionData?.restauration_apprenant !== null && sessionData?.restauration_apprenant !== undefined ? parseFloat(sessionData.restauration_apprenant) : 25,
      livret_apprenant: sessionData?.livret_apprenant !== null && sessionData?.livret_apprenant !== undefined ? parseFloat(sessionData.livret_apprenant) : 6,
      commission_commerciale: sessionData?.commission_commerciale !== null && sessionData?.commission_commerciale !== undefined ? parseFloat(sessionData.commission_commerciale) : 25,
      trainer_rate_day: sessionData?.trainer_rate_day !== null && sessionData?.trainer_rate_day !== undefined ? parseFloat(sessionData.trainer_rate_day) : 1500,
      trainer_days: sessionData?.trainer_days !== null && sessionData?.trainer_days !== undefined ? parseFloat(sessionData.trainer_days) : 1
    });
    setOpenCostDialog(true);
  };

  const handleSaveCosts = async () => {
    try {
      setIsLoading(true);
      const fields = [
        { name: 'frais_deplacement', value: costForm.frais_deplacement },
        { name: 'frais_hebergement', value: costForm.frais_hebergement },
        { name: 'frais_salle', value: costForm.frais_salle },
        { name: 'autres_charges', value: costForm.autres_charges },
        { name: 'restauration_apprenant', value: costForm.restauration_apprenant },
        { name: 'livret_apprenant', value: costForm.livret_apprenant },
        { name: 'commission_commerciale', value: costForm.commission_commerciale },
        { name: 'trainer_rate_day', value: costForm.trainer_rate_day },
        { name: 'trainer_days', value: costForm.trainer_days }
      ];

      for (const field of fields) {
        const originalVal = sessionData[field.name] !== undefined && sessionData[field.name] !== null
          ? parseFloat(sessionData[field.name])
          : (field.name === 'restauration_apprenant' ? 25 : field.name === 'livret_apprenant' ? 6 : field.name === 'commission_commerciale' ? 25 : field.name === 'trainer_rate_day' ? 1500 : field.name === 'trainer_days' ? 1 : 0);
        
        if (parseFloat(field.value) !== originalVal) {
          await sessionApi.editSession(field.name, field.value, sessionId, localStorage.getItem('accessToken'));
        }
      }

      toast.success('Les coûts ont été enregistrés avec succès !');
      
      setSessionData(prev => ({
        ...prev,
        frais_deplacement: costForm.frais_deplacement,
        frais_hebergement: costForm.frais_hebergement,
        frais_salle: costForm.frais_salle,
        autres_charges: costForm.autres_charges,
        restauration_apprenant: costForm.restauration_apprenant,
        livret_apprenant: costForm.livret_apprenant,
        commission_commerciale: costForm.commission_commerciale,
        trainer_rate_day: costForm.trainer_rate_day,
        trainer_days: costForm.trainer_days
      }));

      setOpenCostDialog(false);
    } catch (err) {
      console.error(err);
      toast.error('Erreur lors de l\'enregistrement des coûts.');
    } finally {
      setIsLoading(false);
    }
  };

  
  const downloadAgrement = async (id) => {
    try {
      setIsLoading(true);
      const response = await customerApi.downloadAgrement(id, localStorage.getItem('accessToken'));
      if (response.status === 500) {
        toast.error('Une erreur est survenue lors du téléchargement de la convention !');
      } else if (response.status === 400) {
        toast.error(response.errorMessage);
      } else {
        toast.success('Téléchargement effectué avec succès !');
        getInfoFactu();
      }
      setIsLoading(false);
      setOpenCommonDialog(false);

    } catch (err) {
      console.clear();
      console.error(err);
      setOpenCommonDialog(false);
      setShowCheckUserDataAlert(true);
      setIsLoading(false);
      toast.error('Une erreur est survenue lors du téléchargement !');
    }
  };

  const downloadCerificate = async (id) => {
    try {
      setIsLoading(true);
      const response = await customerApi.downloadCerificate(id, localStorage.getItem('accessToken'));
      if (response.status === 500) {
        toast.error('Une erreur est survenue lors du téléchargemen de l\'attestation !');
      } else if (response.status === 400) {
        toast.error(response.errorMessage);
      } else {
        toast.success('Téléchargement effectué avec succès !');
        getInfoFactu();
      }
      setIsLoading(false);
      setOpenCommonDialog(false);
    } catch (err) {
      console.clear();
      console.error(err);
      setOpenCommonDialog(false);
      setShowCheckUserDataAlert(true);
      setIsLoading(false);
      toast.error('Une erreur est survenue lors du téléchargement !');
    }
  };

  const downloadSwarnStatement = async (id) => {
    try {
      setIsLoading(true);
      const response = await customerApi.downloadSwarnStatement(id, localStorage.getItem('accessToken'));
      if (response.status === 500) {
        toast.error('Une erreur est survenue lors du téléchargemen de l\'attestation !');
      } else if (response.status === 400) {
        toast.error(response.errorMessage);
      } else {
        toast.success('Téléchargement effectué avec succès !');
        getInfoFactu();
      }
      setIsLoading(false);
      setOpenCommonDialog(false);
    } catch (err) {
      console.clear();
      console.error(err);
      setOpenCommonDialog(false);
      setShowCheckUserDataAlert(true);
      setIsLoading(false);
      toast.error('Une erreur est survenue lors du téléchargement !');
    }
  };

  const downloadCertificate = async (id) => {
    try {
      setIsLoading(true);
      const response = await customerApi.downloadCertificate(
        id,
        localStorage.getItem("accessToken")
      );
      if (response.status === 500) {
        toast.error(
          "Une erreur est survenue lors du téléchargemen de l'attestation !"
        );
      } else if (response.status === 400) {
        toast.error(response.errorMessage);
      } else {
        toast.success("Téléchargement effectué avec succès !");
        getInfoFactu();
      }
      setIsLoading(false);
      setOpenCommonDialog(false);
    } catch (err) {
      console.clear();
      console.error(err);
      setOpenCommonDialog(false);
      setShowCheckUserDataAlert(true);
      setIsLoading(false);
      toast.error("Une erreur est survenue lors du téléchargement !");
    }
  };

  const sendAgreement = async (id) => {
    try {
      setIsLoading(true);
      const response = await customerApi.sendAgreement(id, localStorage.getItem('accessToken'));
      if (response.status === 500) {
        toast.error('Une erreur est survenue lors de l\'envoi de la convention !');
      } else if (response.status === 400) {
        toast.error(response.errorMessage);
      } else {
        toast.success('Convention de formation envoyée avec succès !');
        getInfoFactu();
      }
      setIsLoading(false);
      setOpenCommonDialog(false);
    } catch (err) {
      console.error(err);
      setOpenCommonDialog(false);
      setShowCheckUserDataAlert(true);
      setIsLoading(false);
      toast.error('Une erreur est survenue lors de l\'envoi de la convention !');
    }
  };

  const sendCertificate = async (id) => {
    try {
      setIsLoading(true);
      const response = await customerApi.sendCertificate(id, localStorage.getItem('accessToken'));
      if (response.status === 500) {
        toast.error('Une erreur est survenue lors de l\'envoi de l\'attestation !');
      } else if (response.status === 400) {
        toast.error(response.errorMessage);
      } else {
        toast.success('Attestation de fin de formation envoyée avec succès !');
        getInfoFactu();
      }
      setIsLoading(false);
      setOpenCommonDialog(false);
    } catch (err) {
      console.clear();
      console.error(err);
      toast.error('Une erreur est survenue lors de l\'envoi de l\'attestation !');
      setIsLoading(false);
      setOpenCommonDialog(false);
      setShowCheckUserDataAlert(true);
    }
  };

  const downloadMultipleAgreements = async () => {
    try {
      setIsLoading(true);
      const selectedRowsIDs = selectedRows.map((row) => row.id);
      const response = await customerApi.downloadMultipleAgreements(
        selectedRowsIDs,
        sessionId,
        localStorage.getItem("accessToken")
      );
      console.clear();
      if (response.some((res) => res.status === "error")) {
        toast.error(
          "Une ou plusieurs conventions n'ont pas pu être téléchargées. Veuillez vérifier que toutes informations nécessaires au téléchargement sont bien renseignées !"
        );
      } else {
        toast.success("Téléchargement effectué avec succès !");
        // getSession();
        // setSelectedRows([]);
      }
      setIsLoading(false);
      setOpenCommonDialog(false);
    } catch (err) {
      console.clear();
      console.error(err);
      setOpenCommonDialog(false);
      setShowCheckUserDataAlert(true);
      setIsLoading(false);
      toast.error("Une erreur est survenue lors du téléchargement !");
    }
  };
  
  const downloadMultipleCertificates = async () => {
    try {
      setIsLoading(true);
      const selectedRowsIDs = selectedRows.map((row) => row.id);
      const response = await customerApi.downloadMultipleCertificates(
        selectedRowsIDs,
        sessionId,
        localStorage.getItem("accessToken")
      );
      console.clear();
      if (response.some((res) => res.status === "error")) {
        toast.error(
          "Une ou plusieurs certificats n'ont pas pu être téléchargés. Veuillez vérifier que toutes informations nécessaires au téléchargement sont bien renseignées !"
        );
      } else {
        toast.success("Téléchargement effectué avec succès !");
        // getSession();
        // setSelectedRows([]);
      }
      setIsLoading(false);
      setOpenCommonDialog(false);
    } catch (err) {
      console.clear();
      console.error(err);
      setOpenCommonDialog(false);
      setShowCheckUserDataAlert(true);
      setIsLoading(false);
      toast.error("Une erreur est survenue lors du téléchargement !");
    }
  };

  const downloadMultipleSwarnStatements = async () => {
    try {
      setIsLoading(true);
      const selectedRowsIDs = selectedRows.map((row) => row.id);
      const response = await customerApi.downloadMultipleSwarnStatements(
        selectedRowsIDs,
        sessionId,
        localStorage.getItem("accessToken")
      );
      console.clear();
      if (response.some((res) => res.status === "error")) {
        toast.error(
          "Une ou plusieurs attestations n'ont pas pu être téléchargées. Veuillez vérifier que toutes informations nécessaires au téléchargement sont bien renseignées !"
        );
      } else {
        toast.success("Téléchargement effectué avec succès !");
        // getSession();
        // setSelectedRows([]);
      }
      setIsLoading(false);
      setOpenCommonDialog(false);
    } catch (err) {
      console.clear();
      console.error(err);
      setOpenCommonDialog(false);
      setShowCheckUserDataAlert(true);
      setIsLoading(false);
      toast.error("Une erreur est survenue lors du téléchargement !");
    }
  };

  const sendSwarnStatement = async (id) => {
    try {
      setIsLoading(true);
      const response = await customerApi.sendSwarnStatement(id, localStorage.getItem('accessToken'));
      console.clear();
      if (response.status === 500) {
        toast.error('Une erreur est survenue lors de l\'envoi de l\'attestation !');
      } else if (response.status === 400) {
        toast.error(response.errorMessage);
      } else {
        toast.success('Attestation sur l\'honneur envoyée avec succès !');
        getInfoFactu();
      }
      setIsLoading(false);
      setOpenCommonDialog(false);
    } catch (err) {
      console.clear();
      console.error(err);
      toast.error('Une erreur est survenue lors de l\'envoi de l\'attestation !');
      setIsLoading(false);
      setOpenCommonDialog(false);
      setShowCheckUserDataAlert(true);
    }
  };

  const sendMultipleAgreements = async () => {
    try {
      setIsLoading(true);
      const selectedRowsIDs = selectedRows.map((row) => row.id);
      const response = await customerApi.sendMultipleAgreements(selectedRowsIDs, localStorage.getItem('accessToken'));
      console.clear();
      if (response.status === 500) {
        toast.error('Une erreur est survenue lors de l\'envoi de l\'attestation !');
      } else if (response.status === 400) {
        toast.error(response.errorMessage);
      } else {
        toast.success('Attestation sur l\'honneur envoyée avec succès !');
        getInfoFactu();
        setSelectedRows([]);
      }
      setIsLoading(false);
      setOpenCommonDialog(false);
    } catch (err) {
      console.clear();
      console.error(err);
      toast.error('Une erreur est survenue lors de l\'envoi de l\'attestation !');
      setIsLoading(false);
      setOpenCommonDialog(false);
      setShowCheckUserDataAlert(true);
    }
  };

  const sendMultipleSwarnStatements = async () => {
    try {
      setIsLoading(true);
      const selectedRowsIDs = selectedRows.map((row) => row.id);
      const response = await customerApi.sendMultipleSwarnStatements(selectedRowsIDs, localStorage.getItem('accessToken'));
      console.clear();
      if (response.status === 500) {
        toast.error('Une erreur est survenue lors de l\'envoi de l\'attestation !');
      } else if (response.status === 400) {
        toast.error(response.errorMessage);
      } else {
        toast.success('Attestation sur l\'honneur envoyée avec succès !');
        getInfoFactu();
        setSelectedRows([]);
      }
      setIsLoading(false);
      setOpenCommonDialog(false);
    } catch (err) {
      console.clear();
      console.error(err);
      toast.error('Une erreur est survenue lors de l\'envoi de l\'attestation !');
      setIsLoading(false);
      setOpenCommonDialog(false);
      setShowCheckUserDataAlert(true);
    }
  };

  const sendMultipleCertificates = async () => {
    try {
      setIsLoading(true);
      const selectedRowsIDs = selectedRows.map((row) => row.id);
      const response = await customerApi.sendMultipleCertificates(
        selectedRowsIDs,
        localStorage.getItem("accessToken")
      );
      console.clear();
      if (response.some((res) => res.status === "error")) {
        toast.error(
          "Une erreur est survenue lors de l'envoi des certificats de réuissites !"
        );
      } else {
        toast.success("Les certificats de réuissites ont envoyés avec succès !");
        getInfoFactu();
        setSelectedRows([]);
      }
      setIsLoading(false);
      setOpenCommonDialog(false);
    } catch (err) {
      console.clear();
      console.error(err);
      toast.error("Une erreur est survenue lors de l'envoi de l'attestation !");
      setIsLoading(false);
      setOpenCommonDialog(false);
      setShowCheckUserDataAlert(true);
    }
  };

  const handleTooltipClose = () => {
    setOpenTooltip(false);
  };

  const handleTooltipOpen = () => {
    setOpenTooltip(true);
  };

  // eslint-disable-next-line consistent-return
  const hasCompletedProfile = (row) => {
    if (row.adeli_rpps === '' || row.email === '' || row.firstname === '' || row.lastname === '' || row.profession === '' || row.civilite === '' || row.adress === '' || row.city === '' || row.zip === '') return false;
    return true;
  };

  const [errors, setErrors] = useState([]);
  const [openErrors, setOpenErrors] = useState(false);

  const getInfoFactu = useCallback(async () => {
    try {
      const data = await sessionApi.getInfoFactu(sessionId, localStorage.getItem('accessToken'));
      if (mounted.current && data.status !== 400) {
        setRows(data.data.apprenants.map((customer) => ({
          id: customer.id,
          customers_id: customer.customers_id,
          firstname: customer.firstname,
          lastname: customer.lastname,
          profession: customer.profession,
          phone: customer.phone,
          primary_connection: moment(customer.primary_connection).format('DD/MM/YYYY HH:mm:ss'),
          last_connection: moment(customer.last_connection).format('DD/MM/YYYY HH:mm:ss'),
          real_price: customer.real_price,
          financier_id: customer.financier_id || 0,
          progression: customer.progression,
          attest_dpc: customer.attest_dpc,
          attest_honneur: customer.attest_honneur,
          attest_user: customer.attest_user,
          agreement_sent: customer.agreement_sent,
          agreement_completed: customer.agreement_completed,
          honor_sent: customer.honor_sent,
          honor_completed: customer.honor_completed,
          certificate_sent: customer.certificate_sent
        })));
        let tempTotal = 0;
        data.data.apprenants.forEach((apprenant) => {
          tempTotal += apprenant.progression === 100 ? apprenant.real_price : 0;
        });
        setTotal(tempTotal);
        setInfoFactu(data.data.info_factu);
        setHonneur(data.data.honneur);
        setUsers(data.data.users);
        // const tempCustomersId = [];
        // data.data.apprenants.forEach((customer) => { tempCustomersId.push(customer.customers_id); });
        setCustomers(data.data.apprenants);
      }
    } catch (err) {
      console.error(err);
      // navigate('/404', { replace: true });
    }
  }, [mounted]);

  useEffect(() => {
    getInfoFactu();
  }, [getInfoFactu]);

  // Charger la liste des financeurs
  useEffect(() => {
    const loadFinanciers = async () => {
      try {
        const response = await formationApi.getFinanciers(localStorage.getItem("accessToken"));
        if (response.status === 200) {
          setFinanciers(response.data);
        }
      } catch (err) {
        console.error("Erreur lors du chargement des financeurs:", err);
        // En cas d'erreur, utiliser une liste par défaut
        setFinanciers([
          { id: 0, name: "Auto-financement" },
          { id: 1, name: "DPC" },
          { id: 2, name: "FIFPL" },
          { id: 3, name: "OPCO" },
          { id: 4, name: "Pôle Emploi" },
          { id: 5, name: "Région" }
        ]);
      }
    };
    loadFinanciers();
  }, []);

  const changeAttesCustomer = useCallback(
    async (id, value, field) => {
      try {
        const values = { id, value, field };
        await sessionApi.changeAttesCustomer(values, localStorage.getItem('accessToken'));
      } catch (err) {
        console.error(err);
        toast.error('Il y a eu un souci lors de la modification !');
      }
    }
  );

  const changeFactuSession = useCallback(
    async (value, field) => {
      try {
        const values = { id: sessionId, value, field, userId: user.id };
        await sessionApi.changeFactuSession(values, localStorage.getItem('accessToken'));
      } catch (err) {
        console.error(err);
        toast.error('Il y a eu un souci lors de la modification !');
      }
    }
  );

  // eslint-disable-next-line consistent-return
  const handleLogs = async (learnerSessionId, returnFileForZip, isLongPress = false) => {

    // Vérifier le tenant pour déterminer si l'option long press doit être désactivée
    if (!['apteed', 'hp', 'onedys'].includes(tenant.toLowerCase())) {
      isLongPress = false;
    }
    try {
      const logs = await sessionApi.getAttestationLogs(learnerSessionId, isLongPress, localStorage.getItem('accessToken'));

      const units = logs.data.units.filter((el) => typeof (el.length) === 'undefined');
      const tableExcel = [];

      units.forEach((element) => {
        tableExcel.push(['Nom', 'Prénom', 'Email du participant', 'ID de la session', 'Nom du module', 'Connexion - Date et heure', 'Déconnexion - Date et heure', 'Temps passé', 'Progression (%)']);
        // On fait attention à bien enlever les virgules dans les noms de modules pour éviter les erreurs lors de l'upload
        element.codeco.forEach((cdc) => tableExcel.push([`${logs.data.lastname}`, `${logs.data.firstname}`, `${logs.data.email}`, `${logs.data.program_number}`, `${cdc.module_name.replaceAll(',', '')}`, `${cdc.connect}`, `${cdc.disconnect}`, `${cdc.duration}`, `${cdc.progression}`]));
        tableExcel.push(['', '', '', '', `${element.expected_time}`, '', '', `${element.total_time}`]);
        tableExcel.push([]);
      });
      const worksheet = XLSX.utils.aoa_to_sheet(
        tableExcel
      );

      const colNum = XLSX.utils.decode_col('H');
      const fmt = 'h:mm:ss';

      const range = XLSX.utils.decode_range(worksheet['!ref']);
      for (let i = range.s.r + 1; i <= range.e.r; ++i) {
        const ref = XLSX.utils.encode_cell({ r: i, c: colNum });
        if (worksheet[ref] && worksheet[ref].v.includes(':')) {
          worksheet[ref].z = fmt;
        }
      }

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, worksheet, 'Logs');

      if (returnFileForZip) {
        /* generate XLSX file */
        return XLSX.write(wb, { type: 'array', bookType: 'xlsx' });
      }
      /* generate XLSX file and send to client */
      XLSX.writeFile(wb, `User ${logs.data.lastname} ${logs.data.firstname}.xlsx`);
    } catch (err) {
      console.error(err);
      toast.error('Il y a eu un souci lors de la génération de l\'attestation !');
    }
  };

  const generateZipFile = async (isLongPress = false) => {
    try {
      // Ouvrir la dialog de progression
      setOpenProgressDialog(true);
      setProgressValue(0);
      setProgressText('Initialisation...');

      const zip = new JSZip();
      const totalCustomers = customers.length;
      
      // Parcours de chaque identifiant et génération du fichier XLSX correspondant
      for (let i = 0; i < customers.length; i++) {
        const customer = customers[i];
        
        // Mettre à jour la progression
        const progress = Math.round(((i + 1) / totalCustomers) * 100);
        setProgressValue(progress);
        setProgressText(`Génération du fichier pour ${customer.firstname} ${customer.lastname} (${i + 1}/${totalCustomers})`);
        
        // eslint-disable-next-line no-await-in-loop
        const workbook = await handleLogs(customer.id, true, isLongPress);
        // Ajout du fichier XLSX à l'archive zip
        zip.file(`User ${customer.lastname.replace(/\//g, '-')} ${customer.firstname.replace(/\//g, '-')}.xlsx`, workbook, { binary: true });
      }

      // Mise à jour finale de la progression
      setProgressValue(100);
      setProgressText('Finalisation du fichier ZIP...');

      // Génération du fichier zip
      const zipContent = await zip.generateAsync({ type: 'blob' });
      const blobUrl = URL.createObjectURL(zipContent);
      
      // Envoi du fichier zip au client
      saveAs(blobUrl, `logs_${sessionId}_${moment().format('DDMMYYYY')}.zip`);
      
      // on loggue l'utilisation du bouton
      await logApi.saveLogAllLogs(sessionId, localStorage.getItem('accessToken'));
      
      // Fermer la dialog après un court délai pour montrer le 100%
      setTimeout(() => {
        setOpenProgressDialog(false);
        setProgressValue(0);
        setProgressText('');
      }, 1000);
      
    } catch (err) {
      console.error(err);
      setOpenProgressDialog(false);
      setProgressValue(0);
      setProgressText('');
      throw new Error('Une erreur s\'est produite lors de la génération du fichier ZIP.');
    }
  };

  const handleGetAttestationsDPC = async () => {
    try {
      const data = await sessionApi.getAttestationsDPC(sessionId, localStorage.getItem('accessToken'));
      const merger = new PDFMerger();

      await Promise.all(data.data.apprenants.map(async (customer) => {
        const element = await pdf(
          <AttestationPDF
            customer={customer}
            formation={data.data.formation}
            orientations={data.data.orientations}
          />
        ).toBlob();
        await merger.add(element);
      }));

      const mergedPdf = await merger.saveAsBlob();

      const fileURL = URL.createObjectURL(mergedPdf);
      window.open(fileURL, '_blank');
    } catch (err) {
      console.error(err);
      toast.error('Il y a eu un souci lors de la génération des documents !');
    }
  };

  const handleCloseErrors = () => {
    setOpenErrors(false);
  };  
  const handleErrors = () => {
    setOpenErrors(true);
  };

  const handleGetTracabilite = async () => {
    const unitsTable = await sessionApi.getTraca(sessionId, localStorage.getItem('accessToken'));
    // const table = customers.filter((customer) => customer.progression === 100).map((customer) => ({ nom: customer.customerLastname, prenom: customer.customerFirstname, rpps: customer.adeli_rpps, day1: customer.primary_connection, lastDay: customer.last_connection, tempsTotal: customer.duration !== null ? customer.duration.replace('d', 'j') : customer.duration }));
    // const unitsTable = table.sort((a, b) => a.nom.localeCompare(b.nom));

    const worksheetData = [];
    for (let i = 0; i < unitsTable.data.length; i++) {
      const oneUnit = unitsTable.data[i];
      for (let j = 0; j < oneUnit.length; j++) {
        const tt = oneUnit[j];
        const rowData = [
          [tt.lastname, tt.firstname, tt.email, tt.adeli_rpps, 'oui', tt.first_connection, tt.last_connection, tt.real_duration]
        ];
        worksheetData.push(...rowData);
      }
      if (i < unitsTable.data.length - 1) {
        worksheetData.push([]);
      }
    }

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    // const end = trueTable.filter((customer) => moment(customer.lastDay).unix() > moment(session.end_date).unix());
    // const start = trueTable.filter((customer) => moment(customer.day1).unix() < moment(session.start_date).unix());
    // let message = '';
    // message += start.length > 0 ? 'Les apprenants qui ont une date de première connexion antérieure à celle du début de la session: \r\n' : '';
    // start.forEach((name) => {
    //   message += `${name.nom} ${name.prenom} \n`;
    // });
    //   <br />;
    //   message += end.length > 0 ? '\n Les apprenants qui ont une date de dernière connexion postérieure à celle de la fin de la session:  \r\n' : '';
    //   end.forEach((name) => {
    //     message += `${name.nom} ${name.prenom} \n`;
    //   });
    //   setAlertMessage(message);
    //   if (message !== '') {
    //     setShowAlert(true);
    //   }
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, worksheet, 'Traçabilité');
    /* generate XLSX file and send to client */
    XLSX.writeFile(wb, `Traçabilité ${formation.formationName.substring(0, 25)} session ${session.number_session}.xlsx`);
    // gestion erreurs
    if (unitsTable.errors.length > 0) {
      setErrors(unitsTable.errors);
      handleErrors();
    }
  };

  const handleCloseDialog = () => {
    setShowAlert(false);
  };

  const columns = [
    {
      field: 'firstname',
      headerName: 'Prénom',
      renderCell: (cellValues) => (
        <Tooltip
          title={(
            <>
              <div>{`Téléphone: ${cellValues.row.phone || '—'}`}</div>
              <div>{`Profession: ${cellValues.row.profession || '—'}`}</div>
            </>
          )}
        >
          <Link
            component={RouterLink}
            to={`/dashboard/customers/${cellValues.row.customers_id}`}
            variant="subtitle2"
          >
            {cellValues.row.firstname}
          </Link>
        </Tooltip>
      ),
      width: 200,
    },
    {
      field: 'lastname',
      headerName: 'Nom',
      renderCell: (cellValues) => (
        <Tooltip
          title={(
            <>
              <div>{`Téléphone: ${cellValues.row.phone || '—'}`}</div>
              <div>{`Profession: ${cellValues.row.profession || '—'}`}</div>
            </>
          )}
        >
          <Link
            component={RouterLink}
            to={`/dashboard/customers/${cellValues.row.customers_id}`}
            variant="subtitle2"
          >
            {cellValues.row.lastname}
          </Link>
        </Tooltip>
      ),
      width: 200,
    },
    
    {
      field: 'primary_connection',
      headerName: 'Première connexion',
      width: 200,
    },
    {
      field: 'last_connection',
      headerName: 'Dernière connexion',
      width: 200,
    },
    {
      field: 'financier_id',
      headerName: 'Financeur',
      valueFormatter: (params) => {
        if (params.value === 0) return "Auto-financement";
        const financier = financiers.find(f => f.id === params.value);
        return financier ? financier.name : "Non défini";
      },
      width: 90,
    },
    {
      field: 'real_price',
      headerName: 'Prix',
      renderCell: (params) => (`${params.value} €`),
      width: 90,
    },
    {
      field: 'attest_dpc',
      headerName: 'Attes DPC',
      renderCell: (cellValues) => (
        <Switch
          edge="end"
          onChange={() => { cellValues.row.attest_dpc = !cellValues.row.attest_dpc; changeAttesCustomer(cellValues.row.id, cellValues.row.attest_dpc, 'attest_dpc'); }}
          defaultChecked={cellValues.row.attest_dpc}
          value={cellValues.row.attest_dpc}
          disabled={cellValues.row.progression !== 100}
        />
      ),
      width: 90,
    },
    {
      field: 'attest_honneur',
      headerName: 'Attes honneur',
      width: 90,
      renderCell: (cellValues) => (
        <Switch
          edge="end"
          onChange={() => { cellValues.row.attest_honneur = !cellValues.row.attest_honneur; changeAttesCustomer(cellValues.row.id, cellValues.row.attest_honneur, 'attest_honneur'); }}
          defaultChecked={cellValues.row.attest_honneur}
          value={cellValues.row.attest_honneur}
          disabled={!honneur}
        />
      ),
    },
    {
      field: 'attest_user',
      headerName: 'Logs',
      width: 80,
      renderCell: (cellValues) => (
        <Switch
          edge="end"
          onChange={() => { cellValues.row.attest_user = !cellValues.row.attest_user; changeAttesCustomer(cellValues.row.id, cellValues.row.attest_user, 'attest_user'); }}
          defaultChecked={cellValues.row.attest_user}
          value={cellValues.row.attest_user}
        />
      ),
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      width: 200,
      cellClassName: 'actions',
      getActions: (cellValues) => [
        <>
          {/* Permet de déterminer si le profil de l'apprenant est complet avant envoi d'attestation */}
          <div sx={{ marginRight: '10px' }}>
            {!hasCompletedProfile(cellValues.row) && <AdjustOutlinedIcon sx={{ fontSize: 10, color: 'red' }} />}
          </div>
          <Tooltip title="Convention de formation">
            <GridActionsCellItem
              icon={<SendIcon />}
              onClick={() => {
                setDialogText(!cellValues.row.agreement_sent
                  ? `Vous êtes sur le point d\'envoyer la convention de formation de l\'apprenant ${cellValues.row.firstname} ${cellValues.row.lastname} pour signature. Cliquez sur envoyer pour confirmer.`
                  : `Attention ! Ce document a déjà été envoyé et est en attente de signature.`);
                setDialogAction('send-agreement');
                setOpenCommonDialog(true);
                setCurrentRowLearnerSessionId(cellValues.row.id);
              }}
              label="Envoyer la convention"
              disabled={!hasCompletedProfile(cellValues.row)}
              style={{ color : cellValues.row.agreement_completed
                ? '#7EB627'
                : cellValues.row.agreement_sent ? '#4A86CE' : 'inherit'}}
            />
          </Tooltip>
          <Tooltip title="Attestation de formation">
            <GridActionsCellItem
              icon={<AttachEmailIcon />}
              onClick={() => {
                setDialogText(!cellValues.row.certificate_sent
                    ? `Vous êtes sur le point d\'envoyer l\'attestation de fin de formation de l\'apprenant ${cellValues.row.firstname} ${cellValues.row.lastname} . Cliquez sur envoyer pour confirmer.`
                  : `Attention ! Ce document a déjà été envoyé et est en attente de signature.`);
                setDialogAction('send-certificate');
                setOpenCommonDialog(true);
                setCurrentRowLearnerSessionId(cellValues.row.id);
              }}
              label="Attestation de formation"
              disabled={!hasCompletedProfile(cellValues.row)}
              style={{ color : cellValues.row.certificate_completed
                ? '#7EB627'
                : cellValues.row.certificate_sent ? '#4A86CE' : 'inherit'}}
            />
          </Tooltip>
          <Tooltip title="Attestation sur l'honneur">
            <GridActionsCellItem
              icon={<AssignmentIcon />}
              onClick={() => {
                setDialogText(!cellValues.row.honor_sent 
                    ? `Vous êtes sur le point d\'envoyer l\'attestation sur l\'honneur à l\'apprenant ${cellValues.row.firstname} ${cellValues.row.lastname} . Cliquez sur envoyer pour confirmer.`
                  : `Attention ! Ce document a déjà été envoyé et est en attente de signature.`);
                setDialogAction('send-swarn-statement');
                setOpenCommonDialog(true);
                setCurrentRowLearnerSessionId(cellValues.row.id);
              }}
              label="Attestation sur l'honneur"
              disabled={!hasCompletedProfile(cellValues.row)}
              style={{ color : cellValues.row.honor_completed
                ? '#7EB627'
                : cellValues.row.honor_sent ? '#4A86CE' : 'inherit'}}
            />
          </Tooltip>
          <Tooltip title="Télécharger le fichier de logs">
            <LongPressButton
              onShortPress={() => handleLogs(cellValues.row.id, false)}
              onLongPress={() => handleLogs(cellValues.row.id, false, true)}
            >
              <GridActionsCellItem
                icon={<ListIcon />}
                label="Fichier log"
                disabled={(user.id_service !== 0 && user.access_level !== 0)}
              />
            </LongPressButton>
          </Tooltip>
        </>
      ],
    }
  ];

  // Style des boutons secondaires (slate translucide)
  const slateBtnSx = {
    m: 1,
    borderRadius: '12px',
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.84rem',
    color: '#475569',
    border: '1px solid rgba(100, 116, 139, 0.18)',
    backgroundColor: 'rgba(100, 116, 139, 0.07)',
    px: 2.5,
    py: 1,
    '&:hover': { backgroundColor: 'rgba(100, 116, 139, 0.13)', borderColor: 'rgba(100, 116, 139, 0.3)', transform: 'translateY(-1px)' },
    '&.Mui-disabled': { color: 'rgba(100,116,139,0.45)', borderColor: 'rgba(100,116,139,0.12)', backgroundColor: 'rgba(100,116,139,0.04)' },
    transition: 'all 0.2s ease-in-out',
  };
  // Style des boutons primaires (dégradé bleu)
  const gradientBtnSx = {
    borderRadius: '12px',
    textTransform: 'none',
    fontWeight: 700,
    background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
    color: '#fff',
    boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)',
    '&:hover': { background: 'linear-gradient(135deg, #2563eb 0%, #1e40af 100%)' },
    '&.Mui-disabled': { background: 'rgba(100,116,139,0.18)', color: 'rgba(100,116,139,0.5)', boxShadow: 'none' },
  };

  const dialogPaperSx = {
    borderRadius: '20px',
    border: '1px solid #e2e8f0',
    boxShadow: '0 20px 40px -8px rgba(0,0,0,0.18)',
  };

  // Calculations for session profitability
  const count = rows.length;
  const ca = rows.reduce((sum, row) => sum + (parseFloat(row.real_price) || 0), 0);
  const averagePrice = count > 0 ? ca / count : 0;

  const trainerRate = sessionData?.trainer_rate_day !== undefined && sessionData?.trainer_rate_day !== null 
    ? parseFloat(sessionData.trainer_rate_day) 
    : 1500;
  const trainerDays = sessionData?.trainer_days !== undefined && sessionData?.trainer_days !== null 
    ? parseFloat(sessionData.trainer_days) 
    : 1;
  const trainerCost = trainerRate * trainerDays;

  const displacementCost = parseFloat(sessionData?.frais_deplacement) || 0;
  const lodgingCost = parseFloat(sessionData?.frais_hebergement) || 0;
  const roomCost = parseFloat(sessionData?.frais_salle) || 0;
  const otherCost = parseFloat(sessionData?.autres_charges) || 0;

  const restaurationRate = sessionData?.restauration_apprenant !== undefined && sessionData?.restauration_apprenant !== null 
    ? parseFloat(sessionData.restauration_apprenant) 
    : 25;
  const restaurationCost = count * restaurationRate;

  const bookletRate = sessionData?.livret_apprenant !== undefined && sessionData?.livret_apprenant !== null 
    ? parseFloat(sessionData.livret_apprenant) 
    : 6;
  const bookletCost = count * bookletRate;

  const commissionRate = sessionData?.commission_commerciale !== undefined && sessionData?.commission_commerciale !== null 
    ? parseFloat(sessionData.commission_commerciale) 
    : 25;
  const commissionCost = ca * (commissionRate / 100);

  const totalCosts = trainerCost + displacementCost + lodgingCost + roomCost + restaurationCost + bookletCost + commissionCost + otherCost;
  const netResult = ca - totalCosts;
  const margin = ca > 0 ? (netResult / ca) * 100 : 0;
  const isProfitable = netResult >= 0;

  // Preview calculations for Dialog
  const previewTrainerCost = costForm.trainer_rate_day * costForm.trainer_days;
  const previewTotalCosts = previewTrainerCost + costForm.frais_deplacement + costForm.frais_hebergement + costForm.frais_salle + (count * costForm.restauration_apprenant) + (count * costForm.livret_apprenant) + (ca * (costForm.commission_commerciale / 100)) + costForm.autres_charges;
  const previewNetResult = ca - previewTotalCosts;
  const previewMargin = ca > 0 ? (previewNetResult / ca) * 100 : 0;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
    <Dialog open={openErrors} onClose={handleCloseErrors} PaperProps={{ sx: dialogPaperSx }}>
        <DialogTitle sx={{ fontWeight: 800, color: '#1e293b', display: 'flex', alignItems: 'center', gap: 1 }}>
          <WarningAmberRoundedIcon sx={{ color: '#f59e0b' }} />
          Apprenants dont la synthèse est en erreur
        </DialogTitle>
        <DialogContent>
          {/* <DialogContentText>
            Confirmer le nom et le type de chaque fichier à importer.
          </DialogContentText> */}
          {errors.map((value, _) => (
            <>
              <Typography sx={{ fontWeight: 600, color: '#334155' }}>{`${value.firstname} ${value.lastname}`}</Typography>
              <br />
            </>
          ))}
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handleCloseErrors} sx={gradientBtnSx}>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={4}>
          <Card
            sx={{
              borderRadius: '20px',
              border: '1px solid #e2e8f0',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.07), 0 2px 4px -1px rgba(0, 0, 0, 0.04)',
              background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
              p: 2.5,
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              height: '100%',
            }}
          >
            <Avatar
              sx={{
                width: 56,
                height: 56,
                borderRadius: '16px',
                background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                boxShadow: '0 6px 16px rgba(16, 185, 129, 0.35)',
              }}
            >
              <EuroRoundedIcon sx={{ color: '#fff', fontSize: 30 }} />
            </Avatar>
            <Box>
              <Typography
                variant="subtitle2"
                sx={{ color: '#64748b', fontWeight: 700, textTransform: 'uppercase', fontSize: '0.72rem', letterSpacing: '0.04em' }}
              >
                Total facturable potentiel
              </Typography>
              <Typography
                variant="h4"
                component="div"
                sx={{ fontWeight: 800, color: '#059669', lineHeight: 1.2 }}
              >
                {total.toFixed(2)} €
              </Typography>
            </Box>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Card
            sx={{
              borderRadius: '20px',
              border: '1px solid #e2e8f0',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.07), 0 2px 4px -1px rgba(0, 0, 0, 0.04)',
              background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
              p: 2.5,
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              height: '100%',
            }}
          >
            <Avatar
              sx={{
                width: 56,
                height: 56,
                borderRadius: '16px',
                background: sessionData?.billing_sent
                  ? 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)'
                  : 'linear-gradient(135deg, #64748b 0%, #475569 100%)',
                boxShadow: sessionData?.billing_sent
                  ? '0 6px 16px rgba(59, 130, 246, 0.35)'
                  : '0 6px 16px rgba(100, 116, 139, 0.35)',
              }}
            >
              <FactCheckRoundedIcon sx={{ color: '#fff', fontSize: 30 }} />
            </Avatar>
            <Box sx={{ flexGrow: 1 }}>
              <Typography
                variant="subtitle2"
                sx={{ color: '#64748b', fontWeight: 700, textTransform: 'uppercase', fontSize: '0.72rem', letterSpacing: '0.04em', mb: 1 }}
              >
                Facturation Envoyée
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Button
                  onClick={async () => {
                    if (sessionData?.billing_sent !== 1) {
                      try {
                        await sessionApi.editSession('billing_sent', 1, sessionId, localStorage.getItem('accessToken'));
                        setSessionData(prev => ({ ...prev, billing_sent: 1 }));
                        toast.success('Statut de facturation mis à jour : Envoyée');
                      } catch (err) {
                        console.error(err);
                        toast.error('Erreur lors de la mise à jour.');
                      }
                    }
                  }}
                  variant={sessionData?.billing_sent ? 'contained' : 'outlined'}
                  color="primary"
                  size="small"
                  sx={{
                    borderRadius: '8px',
                    textTransform: 'none',
                    fontWeight: 700,
                    minWidth: '60px',
                    boxShadow: sessionData?.billing_sent ? '0 4px 10px rgba(59, 130, 246, 0.3)' : 'none',
                  }}
                >
                  Oui
                </Button>
                <Button
                  onClick={async () => {
                    if (sessionData?.billing_sent !== 0) {
                      try {
                        await sessionApi.editSession('billing_sent', 0, sessionId, localStorage.getItem('accessToken'));
                        setSessionData(prev => ({ ...prev, billing_sent: 0 }));
                        toast.success('Statut de facturation mis à jour : Non envoyée');
                      } catch (err) {
                        console.error(err);
                        toast.error('Erreur lors de la mise à jour.');
                      }
                    }
                  }}
                  variant={!sessionData?.billing_sent ? 'contained' : 'outlined'}
                  size="small"
                  sx={{
                    borderRadius: '8px',
                    textTransform: 'none',
                    fontWeight: 700,
                    minWidth: '60px',
                    backgroundColor: !sessionData?.billing_sent ? '#64748b' : 'transparent',
                    color: !sessionData?.billing_sent ? '#ffffff' : '#64748b',
                    borderColor: !sessionData?.billing_sent ? '#64748b' : '#cbd5e1',
                    '&:hover': {
                      backgroundColor: !sessionData?.billing_sent ? '#475569' : 'rgba(100, 116, 139, 0.08)',
                      borderColor: '#94a3b8'
                    },
                    boxShadow: !sessionData?.billing_sent ? '0 4px 10px rgba(100, 116, 139, 0.3)' : 'none',
                  }}
                >
                  Non
                </Button>
              </Box>
            </Box>
          </Card>
        </Grid>
      </Grid>
      <Dialog
        open={openCommonDialog}
        onClose={() => setOpenCommonDialog(false)}
        PaperProps={{ sx: dialogPaperSx }}
      >
        <DialogContent>
          <DialogContentText sx={{ color: '#334155', fontWeight: 500 }}>
            { dialogText }
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ p: 2, gap: 0.5 }}>
          <Button
            onClick={() => {
              if (dialogAction === "send-agreement") {
                downloadAgrement(currentRowLearnerSessionId);
              } else if (dialogAction === "send-certificate") {
                downloadCertificate(currentRowLearnerSessionId);
              } else if (dialogAction === "send-swarn-statement") {
                downloadSwarnStatement(currentRowLearnerSessionId);
              } else if (dialogAction === "send-multiple-agreements") {
                downloadMultipleAgreements();
              } else if (dialogAction === "send-multiple-swarn-statements") {
                downloadMultipleSwarnStatements();
              } else if (dialogAction === "send-multiple-certificates") {
                downloadMultipleCertificates();
              }
            }}
            startIcon={<DownloadRoundedIcon />}
            sx={gradientBtnSx}
            disabled={isLoading}
          >
            Télécharger
          </Button>
          <ClickAwayListener onClickAway={handleTooltipClose}>
            <Tooltip
              onClose={handleTooltipClose}
              open={openTooltip}
              disableFocusListener
              disableHoverListener
              disableTouchListener
              title={(
              <Alert
                icon={false}
                style={{ backgroundColor: theme.palette.mode !== 'light' && 'transparent' }}
                sx={{ margin: 0 }}
              >
                <Grid
                  container
                  spacing={0}
                >
                  <Grid
                    item
                    sx={8}
                  >
                    Attention - Cette action est irréversible !
                  </Grid>
                  <Grid
                    item
                    sx={4}
                  >
                    <Button
                      onClick={() => {
                        if (dialogAction === "send-agreement") {
                          sendAgreement(currentRowLearnerSessionId);
                        } else if (dialogAction === "send-certificate") {
                          sendCertificate(currentRowLearnerSessionId);
                        } else if (dialogAction === "send-swarn-statement") {
                          sendSwarnStatement(currentRowLearnerSessionId);
                        } else if (dialogAction === "send-multiple-agreements") {
                          sendMultipleAgreements();
                        } else if (dialogAction === "send-multiple-swarn-statements") {
                          sendMultipleSwarnStatements();
                        } else if (dialogAction === "send-multiple-certificates") {
                          sendMultipleCertificates();
                        }
                      }}
                      size="small"
                      sx={{ ...slateBtnSx, mt: 1, m: 0 }}
                      disabled={isLoading}
                    >
                      Confirmer
                    </Button>
                  </Grid>
                </Grid>
              </Alert>
            )}
            >
              <Button
                startIcon={<SendIcon />}
                sx={slateBtnSx}
                onClick={handleTooltipOpen}>
                Je souhaite envoyer
              </Button>
            </Tooltip>
          </ClickAwayListener>
          <Button
            onClick={() => setOpenCommonDialog(false)}
            sx={slateBtnSx}
          >
            Annuler
          </Button>
          {isLoading && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center'
            }}
          >
            <CircularProgress />
          </Box>
          )}
        </DialogActions>
      </Dialog>

      <Dialog
        open={showAlert}
        onClose={handleCloseDialog}
        PaperProps={{ sx: dialogPaperSx }}
      >
        <DialogTitle sx={{ fontWeight: 800, color: '#1e293b' }}>
          Différence de dates
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ color: '#334155' }}>
            <span style={{ whiteSpace: 'pre-line' }}>
              {alertMessage}
            </span>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button
            onClick={handleCloseDialog}
            sx={slateBtnSx}
          >
            Annuler
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog de progression pour le téléchargement des logs */}
      <Dialog
        open={openProgressDialog}
        onClose={() => {}} // Empêcher la fermeture pendant le traitement
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: dialogPaperSx }}
      >
        <DialogTitle sx={{ fontWeight: 800, color: '#1e293b' }}>
          Génération des fichiers de logs
        </DialogTitle>
        <DialogContent>
          <Box sx={{ width: '100%', mt: 2 }}>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              {progressText}
            </Typography>
            <BorderLinearProgress 
              variant="determinate" 
              value={progressValue} 
              sx={{ 
                height: 10, 
                borderRadius: 5,
                backgroundColor: theme.palette.grey[200],
                '& .MuiLinearProgress-bar': {
                  borderRadius: 5,
                  background: 'linear-gradient(90deg, #6fcbb6 0%, #9c64f4 100%)',
                }
              }}
            />
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1, textAlign: 'center' }}>
              {progressValue}%
            </Typography>
          </Box>
        </DialogContent>
      </Dialog>

      {/* SECTION BÉNÉFICE ET COÛTS DE LA SESSION */}
      <Card
        sx={{
          mb: 4,
          borderRadius: '24px',
          overflow: 'hidden',
          border: '1px solid',
          borderColor: isProfitable ? '#a7f3d0' : '#fca5a5',
          background: isProfitable 
            ? 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)' 
            : 'linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)',
          boxShadow: '0 10px 30px rgba(0, 0, 0, 0.04)',
          position: 'relative',
          p: 3
        }}
      >
        <Box sx={{ position: 'absolute', top: 0, left: 0, bottom: 0, width: 6, backgroundColor: isProfitable ? '#10b981' : '#ef4444' }} />
        
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', md: 'center' }, gap: 2, mb: 3 }}>
          <Box sx={{ pl: 1 }}>
            <Typography variant="caption" sx={{ fontWeight: 800, color: isProfitable ? '#065f46' : '#991b1b', textTransform: 'uppercase', letterSpacing: '0.08em', fontSize: '0.75rem' }}>
              Bénéfice estimé
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1, mt: 0.5 }}>
              <Typography variant="h3" sx={{ fontWeight: 900, color: isProfitable ? '#065f46' : '#991b1b', letterSpacing: '-0.03em' }}>
                {isProfitable ? '+' : ''}{Math.round(netResult).toLocaleString('fr-FR')} €
              </Typography>
              <Typography variant="subtitle1" sx={{ fontWeight: 700, color: isProfitable ? '#047857' : '#b91c1c' }}>
                ({isProfitable ? '+' : ''}{Math.round(margin)}% de marge)
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ color: isProfitable ? '#047857' : '#b91c1c', fontWeight: 600, mt: 0.5 }}>
              {isProfitable ? 'Session rentable' : 'Session non rentable'} • basé sur {count} inscrit{count > 1 ? 's' : ''}
            </Typography>
          </Box>
          
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', bgcolor: 'rgba(255, 255, 255, 0.6)', border: '1px solid rgba(0,0,0,0.08)', borderRadius: '12px', px: 2, py: 0.5 }}>
              <Typography variant="body2" sx={{ fontWeight: 700, mr: 1, color: '#334155' }}>
                Facturation Envoyée :
              </Typography>
              <Switch
                checked={!!sessionData?.billing_sent}
                onChange={async (e) => {
                  const newVal = e.target.checked ? 1 : 0;
                  try {
                    await sessionApi.editSession('billing_sent', newVal, sessionId, localStorage.getItem('accessToken'));
                    setSessionData(prev => ({ ...prev, billing_sent: newVal }));
                    toast.success('Statut de facturation mis à jour avec succès.');
                  } catch (err) {
                    console.error(err);
                    toast.error('Erreur lors de la mise à jour de la facturation.');
                  }
                }}
                color="primary"
              />
              <Typography variant="body2" sx={{ fontWeight: 800, color: sessionData?.billing_sent ? '#10b981' : '#64748b' }}>
                {sessionData?.billing_sent ? 'Oui' : 'Non'}
              </Typography>
            </Box>

            <Button
              onClick={handleOpenCostDialog}
              variant="outlined"
              startIcon={<EditIcon />}
              sx={{
                borderRadius: '12px',
                textTransform: 'none',
                fontWeight: 700,
                px: 2.5,
                py: 1,
                borderColor: isProfitable ? '#10b981' : '#ef4444',
                color: isProfitable ? '#047857' : '#b91c1c',
                backgroundColor: 'rgba(255, 255, 255, 0.6)',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.9)',
                  borderColor: isProfitable ? '#059669' : '#dc2626',
                }
              }}
            >
              Ajuster les coûts
            </Button>
          </Box>
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, pl: 1, pr: 1 }}>
          {/* CA */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="body2" sx={{ color: '#334155', fontWeight: 600 }}>
              Chiffre d&apos;affaires <span style={{ color: '#64748b', fontWeight: 500 }}>{count} × {Math.round(averagePrice)} €</span>
            </Typography>
            <Typography variant="body2" sx={{ color: '#0f5132', fontWeight: 700 }}>
              +{Math.round(ca).toLocaleString('fr-FR')} €
            </Typography>
          </Box>
          <Divider sx={{ borderColor: 'rgba(0, 0, 0, 0.06)' }} />

          {/* Prestation formateur */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="body2" sx={{ color: '#334155', fontWeight: 600 }}>
              Prestation formateur <span style={{ color: '#64748b', fontWeight: 500 }}>{trainerDays} j × {trainerRate} € {sessionData?.trainer ? `• ${sessionData.trainer}` : ''}</span>
            </Typography>
            <Typography variant="body2" sx={{ color: '#b91c1c', fontWeight: 700 }}>
              -{Math.round(trainerCost).toLocaleString('fr-FR')} €
            </Typography>
          </Box>
          
          {/* Déplacement */}
          {(displacementCost > 0 || parseFloat(sessionData?.frais_deplacement) === 0) && (
            <>
              <Divider sx={{ borderColor: 'rgba(0, 0, 0, 0.06)' }} />
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="body2" sx={{ color: displacementCost > 0 ? '#334155' : '#94a3b8', fontWeight: 600 }}>
                  Déplacement formateur {displacementCost === 0 && <span style={{ fontStyle: 'italic', fontWeight: 400 }}>non renseigné</span>}
                </Typography>
                {displacementCost > 0 && (
                  <Typography variant="body2" sx={{ color: '#b91c1c', fontWeight: 700 }}>
                    -{Math.round(displacementCost).toLocaleString('fr-FR')} €
                  </Typography>
                )}
              </Box>
            </>
          )}

          {/* Hébergement */}
          {(lodgingCost > 0 || parseFloat(sessionData?.frais_hebergement) === 0) && (
            <>
              <Divider sx={{ borderColor: 'rgba(0, 0, 0, 0.06)' }} />
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="body2" sx={{ color: lodgingCost > 0 ? '#334155' : '#94a3b8', fontWeight: 600 }}>
                  Hébergement formateur {lodgingCost === 0 && <span style={{ fontStyle: 'italic', fontWeight: 400 }}>non renseigné</span>}
                </Typography>
                {lodgingCost > 0 && (
                  <Typography variant="body2" sx={{ color: '#b91c1c', fontWeight: 700 }}>
                    -{Math.round(lodgingCost).toLocaleString('fr-FR')} €
                  </Typography>
                )}
              </Box>
            </>
          )}

          {/* Salle */}
          <Divider sx={{ borderColor: 'rgba(0, 0, 0, 0.06)' }} />
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            {sessionData?.meeting_link ? (
              <Typography variant="body2" sx={{ color: '#94a3b8', fontWeight: 600 }}>
                Location salle <span style={{ color: '#94a3b8', fontStyle: 'italic', fontWeight: 400 }}>classe virtuelle</span>
              </Typography>
            ) : (
              <Typography variant="body2" sx={{ color: roomCost > 0 ? '#334155' : '#94a3b8', fontWeight: 600 }}>
                Location salle {roomCost === 0 && <span style={{ fontStyle: 'italic', fontWeight: 400 }}>non renseigné</span>}
              </Typography>
            )}
            {!sessionData?.meeting_link && roomCost > 0 && (
              <Typography variant="body2" sx={{ color: '#b91c1c', fontWeight: 700 }}>
                -{Math.round(roomCost).toLocaleString('fr-FR')} €
              </Typography>
            )}
          </Box>

          {/* Restauration */}
          <Divider sx={{ borderColor: 'rgba(0, 0, 0, 0.06)' }} />
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="body2" sx={{ color: '#334155', fontWeight: 600 }}>
              Restauration <span style={{ color: '#64748b', fontWeight: 500 }}>{count} × {restaurationRate} €</span>
            </Typography>
            <Typography variant="body2" sx={{ color: '#b91c1c', fontWeight: 700 }}>
              -{Math.round(restaurationCost).toLocaleString('fr-FR')} €
            </Typography>
          </Box>

          {/* Livrets */}
          <Divider sx={{ borderColor: 'rgba(0, 0, 0, 0.06)' }} />
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="body2" sx={{ color: '#334155', fontWeight: 600 }}>
              Livrets de formation <span style={{ color: '#64748b', fontWeight: 500 }}>{count} × {bookletRate} €</span>
            </Typography>
            <Typography variant="body2" sx={{ color: '#b91c1c', fontWeight: 700 }}>
              -{Math.round(bookletCost).toLocaleString('fr-FR')} €
            </Typography>
          </Box>

          {/* Commission */}
          <Divider sx={{ borderColor: 'rgba(0, 0, 0, 0.06)' }} />
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="body2" sx={{ color: '#334155', fontWeight: 600 }}>
              Commission commerciale <span style={{ color: '#64748b', fontWeight: 500 }}>{commissionRate}% du CA</span>
            </Typography>
            <Typography variant="body2" sx={{ color: '#b91c1c', fontWeight: 700 }}>
              -{Math.round(commissionCost).toLocaleString('fr-FR')} €
            </Typography>
          </Box>

          {/* Autres charges */}
          {(otherCost > 0 || parseFloat(sessionData?.autres_charges) === 0) && (
            <>
              <Divider sx={{ borderColor: 'rgba(0, 0, 0, 0.06)' }} />
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="body2" sx={{ color: otherCost > 0 ? '#334155' : '#94a3b8', fontWeight: 600 }}>
                  Autres charges {otherCost === 0 && <span style={{ fontStyle: 'italic', fontWeight: 400 }}>non renseigné</span>}
                </Typography>
                {otherCost > 0 && (
                  <Typography variant="body2" sx={{ color: '#b91c1c', fontWeight: 700 }}>
                    -{Math.round(otherCost).toLocaleString('fr-FR')} €
                  </Typography>
                )}
              </Box>
            </>
          )}

          <Divider sx={{ borderBottomWidth: 2, borderColor: isProfitable ? '#a7f3d0' : '#fca5a5' }} />
          
          {/* Résultat net */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pt: 0.5 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 800, color: isProfitable ? '#065f46' : '#991b1b' }}>
              Résultat net
            </Typography>
            <Typography variant="subtitle1" sx={{ fontWeight: 900, color: isProfitable ? '#065f46' : '#991b1b' }}>
              {isProfitable ? '+' : ''}{Math.round(netResult).toLocaleString('fr-FR')} €
            </Typography>
          </Box>
        </Box>
      </Card>

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', flexWrap: 'wrap', alignItems: 'center', mb: 1 }}>
        {/* <Button
          color="primary"
          onClick={handleGetAttestationsDPC}
          sx={{ m: 1 }}
          variant="outlined"
          disabled={user.access_level !== 0}
        >
          Générer les attestations DPC
        </Button> */}
        {/* <Button
          color="primary"
          onClick={handleGetTracabilite}
          sx={{ m: 1 }}
          variant="outlined"
          disabled={user.access_level !== 0}
        >
          Synthèse de suivi des activités non présentielles
        </Button> */}
        <LongPressButton
          onShortPress={() => generateZipFile(false)}
          onLongPress={() => generateZipFile(true)}
        >
        <Button
          startIcon={<DownloadRoundedIcon />}
          sx={slateBtnSx}
        >
          Télécharger les logs
        </Button>
        </LongPressButton>
        {
          selectedRows.length > 0 && (
            <>
            <Button
                  startIcon={<FolderZipIcon />}
                  onClick={() => {
                    setDialogText(`Vous êtes sur le point d\'envoyer ${selectedRows.length} conventions. Voulez-vous continuer ?`);
                    setDialogAction("send-multiple-agreements");
                    setOpenCommonDialog(true);
                  }}
                  sx={slateBtnSx}
                  disabled={user.access_level !== 0}
                >
                  Conventions
                </Button>
                {/* <Button
                  endIcon={<DownloadOutlinedIcon />}
                  color="primary"
                  onClick={downloadMultipleAgreements}
                  sx={{ m: 1 }}
                  variant="outlined"
                  disabled={user.access_level !== 0}
                >
                  Conventions
                </Button> */}
                <Button
                  startIcon={<FolderZipIcon />}
                  onClick={() => {
                    setDialogText(`Vous êtes sur le point d\'envoyer ${selectedRows.length} attestations sur honneur. Voulez-vous continuer ?`);
                    setDialogAction("send-multiple-swarn-statements");
                    setOpenCommonDialog(true);
                  }}
                  sx={slateBtnSx}
                  disabled={user.access_level !== 0}
                >
                  Attestations sur horneur
                </Button>
                {/* <Button
                  endIcon={<DownloadOutlinedIcon />}
                  color="primary"
                  onClick={downloadMultipleSwarnStatements}
                  sx={{ m: 1 }}
                  variant="outlined"
                  disabled={user.access_level !== 0}
                >
                  Attestations sur horneur
                </Button> */}
                <Button
                  startIcon={<FolderZipIcon />}
                  onClick={() => {
                    setDialogText(`Vous êtes sur le point d\'envoyer ${selectedRows.length} certificats de réussite. Voulez-vous continuer ?`);
                    setDialogAction("send-multiple-certificates");
                    setOpenCommonDialog(true);
                  }}
                  sx={slateBtnSx}
                  disabled={user.access_level !== 0}
                >
                  Certificats
                </Button>
              {/* <Chip
                icon={<UploadOutlinedIcon />}
                color="primary"
                label="Conventions"
                variant="outlined"
                sx={{
                  mt: 2,
                  mb: 2,
                  ml: 1,
                }}
                onClick={sendMultipleAgreements}
              /> */}
              {/* <Chip
                icon={<UploadOutlinedIcon />}
                color="primary"
                label="Attestations sur horneur"
                variant="outlined"
                sx={{
                  mb: 2,
                  mt: 2,
                  ml: 1,
                }}
                onClick={sendMultipleSwarnStatements}
              /> */}
            </>
          )
        }
      </Box>
      <Card
        {...other}
        sx={{
          borderRadius: '20px',
          overflow: 'hidden',
          border: '1px solid #e2e8f0',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.07), 0 2px 4px -1px rgba(0, 0, 0, 0.04)',
        }}
      >
        <Box height={600}>
          <DataGrid
            rows={rows}
            columns={columns}
            pageSize={100}
            checkboxSelection
            rowsPerPageOptions={[5]}
            sx={{
              border: 'none',
              fontFamily: 'inherit',
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: theme.palette.mode === 'light' ? 'rgba(248, 250, 252, 0.9)' : 'rgba(15, 23, 42, 0.4)',
                borderBottom: '1px solid',
                borderColor: theme.palette.mode === 'light' ? 'rgba(226, 232, 240, 0.8)' : 'rgba(255, 255, 255, 0.08)',
                borderRadius: 0,
              },
              '& .MuiDataGrid-columnHeaderTitle': {
                fontWeight: 800,
                fontSize: '0.7rem',
                textTransform: 'uppercase',
                letterSpacing: '0.06em',
                color: 'text.secondary',
              },
              '& .MuiDataGrid-columnSeparator': { display: 'none' },
              '& .MuiDataGrid-row': {
                transition: 'background-color 0.15s ease, box-shadow 0.15s ease',
              },
              '& .MuiDataGrid-row:nth-of-type(even)': {
                backgroundColor: theme.palette.mode === 'light' ? 'rgba(248, 250, 252, 0.45)' : 'rgba(255, 255, 255, 0.015)',
              },
              '& .MuiDataGrid-row:hover': {
                backgroundColor: theme.palette.mode === 'light' ? 'rgba(59, 130, 246, 0.05)' : 'rgba(59, 130, 246, 0.09)',
                boxShadow: 'inset 3px 0 0 0 #3b82f6',
              },
              '& .MuiDataGrid-cell': {
                borderColor: theme.palette.mode === 'light' ? 'rgba(226, 232, 240, 0.4)' : 'rgba(255, 255, 255, 0.04)',
              },
              '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': { outline: 'none !important' },
              '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': { outline: 'none !important' },
              '& .MuiDataGrid-footerContainer': {
                borderTop: '1px solid',
                borderColor: theme.palette.mode === 'light' ? 'rgba(226, 232, 240, 0.8)' : 'rgba(255, 255, 255, 0.08)',
                backgroundColor: theme.palette.mode === 'light' ? 'rgba(248, 250, 252, 0.5)' : 'rgba(15, 23, 42, 0.3)',
              },
              '& .MuiCheckbox-root.Mui-checked': { color: '#3b82f6' },
            }}
            onSelectionModelChange={(ids) => {
              const selectedIDs = new Set(ids);
              const _selectedRows = rows.filter((row) =>
                selectedIDs.has(row.id),
              );
              setSelectedRows(_selectedRows);
            }}
          />
        </Box>
      </Card>
      <Grid
        container
        justifyContent="space-between"
        spacing={3}
      >
        <Grid
          item
          md={7}
          xs={12}
        >
          <Card
            {...other}
            sx={{
              mt: 5,
              borderRadius: '20px',
              overflow: 'hidden',
              border: '1px solid #e2e8f0',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.07), 0 2px 4px -1px rgba(0, 0, 0, 0.04)',
              background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
            }}
          >
            <Box sx={{ p: 3, display: 'flex', alignItems: 'center', gap: 1.5, borderBottom: '1px solid #e2e8f0' }}>
              <Avatar sx={{ width: 44, height: 44, borderRadius: '14px', background: 'linear-gradient(135deg, #6366f1 0%, #4338ca 100%)', boxShadow: '0 6px 16px rgba(99, 102, 241, 0.35)' }}>
                <FactCheckRoundedIcon sx={{ color: '#fff' }} />
              </Avatar>
              <Box>
                <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b' }}>Checklist</Typography>
                <Typography variant="caption" sx={{ color: '#64748b' }}>Suivi de l&apos;édition et de la vérification des documents</Typography>
              </Box>
            </Box>
            <Box
              sx={{ mt: 2, px: 2 }}
            >
              <Table sx={{ borderCollapse: 'separate', borderSpacing: '0 8px' }}>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ borderBottom: 'none', fontWeight: 800, color: '#64748b', textTransform: 'uppercase', fontSize: '0.72rem', letterSpacing: '0.04em' }}>
                      Type de document
                    </TableCell>
                    <TableCell sx={{ borderBottom: 'none', fontWeight: 800, color: '#64748b', textTransform: 'uppercase', fontSize: '0.72rem', letterSpacing: '0.04em' }}>
                      Édité
                    </TableCell>
                    <TableCell sx={{ borderBottom: 'none', fontWeight: 800, color: '#64748b', textTransform: 'uppercase', fontSize: '0.72rem', letterSpacing: '0.04em' }}>
                      Vérifié
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow
                    sx={{
                      backgroundColor: 'white',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                      transition: 'transform 0.2s, box-shadow 0.2s',
                      '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' },
                    }}
                  >
                    <TableCell sx={{ borderBottom: 'none', borderRadius: '12px 0 0 12px' }}>
                      <Typography
                        variant="subtitle1"
                        sx={{ fontWeight: 700, color: '#334155' }}
                      >
                        Facture
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ borderBottom: 'none' }}>
                      <Switch
                        edge="end"
                        onClick={(event) => { setInfoFactu((prevState) => ({ ...prevState, factu_edited: !infoFactu.factu_edited })); changeFactuSession(event.target.checked, 'factu_edited'); }}
                        checked={infoFactu.factu_edited}
                        value={infoFactu.factu_edited}
                        disabled={infoFactu.factu_edited && user.id_service !== 0}
                      />
                      <Typography variant="caption" sx={{ display: 'block', color: '#64748b', fontWeight: 600 }}>
                        {infoFactu.source_factu_edited !== null
                          ? `${users.length !== 0 ? users.find((us) => us.id === infoFactu.source_factu_edited).firstname : ''} ${users.length !== 0 ? users.find((us) => us.id === infoFactu.source_factu_edited).lastname : ''} le ${moment(infoFactu.date_factu_edited).format('DD/MM/YYYY HH:mm:ss')}`
                          : ''}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ borderBottom: 'none', borderRadius: '0 12px 12px 0' }}>
                      <Switch
                        edge="end"
                        onClick={(event) => { setInfoFactu((prevState) => ({ ...prevState, factu_verified: !infoFactu.factu_verified })); changeFactuSession(event.target.checked, 'factu_verified'); }}
                        checked={infoFactu.factu_verified}
                        value={infoFactu.factu_verified}
                        disabled={infoFactu.factu_verified && user.id_service !== 0}
                      />
                      <Typography variant="caption" sx={{ display: 'block', color: '#64748b', fontWeight: 600 }}>
                        {infoFactu.source_factu_verified !== null
                          ? `${users.length !== 0 ? users.find((us) => us.id === infoFactu.source_factu_verified).firstname : ''} ${users.length !== 0 ? users.find((us) => us.id === infoFactu.source_factu_verified).lastname : ''} le ${moment(infoFactu.date_factu_verified).format('DD/MM/YYYY HH:mm:ss')}`
                          : ''}
                      </Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow
                    sx={{
                      backgroundColor: 'white',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                      transition: 'transform 0.2s, box-shadow 0.2s',
                      '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' },
                    }}
                  >
                    <TableCell sx={{ borderBottom: 'none', borderRadius: '12px 0 0 12px' }}>
                      <Typography
                        variant="subtitle1"
                        sx={{ fontWeight: 700, color: '#334155' }}
                      >
                        Attestations DPC
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ borderBottom: 'none' }}>
                      <Switch
                        edge="end"
                        onClick={(event) => { setInfoFactu((prevState) => ({ ...prevState, attestation_edited: !infoFactu.attestation_edited })); changeFactuSession(event.target.checked, 'attestation_edited'); }}
                        checked={infoFactu.attestation_edited}
                        value={infoFactu.attestation_edited}
                        disabled={infoFactu.attestation_edited && user.id_service !== 0}
                      />
                      <Typography variant="caption" sx={{ display: 'block', color: '#64748b', fontWeight: 600 }}>
                        {infoFactu.source_attestation_edited !== null
                          ? `${users.length !== 0 ? users.find((us) => us.id === infoFactu.source_attestation_edited).firstname : ''} ${users.length !== 0 ? users.find((us) => us.id === infoFactu.source_attestation_edited).lastname : ''} le ${moment(infoFactu.date_attestation_edited).format('DD/MM/YYYY HH:mm:ss')}`
                          : ''}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ borderBottom: 'none', borderRadius: '0 12px 12px 0' }}>
                      <Switch
                        edge="end"
                        onClick={(event) => { setInfoFactu((prevState) => ({ ...prevState, attestation_verified: !infoFactu.attestation_verified })); changeFactuSession(event.target.checked, 'attestation_verified'); }}
                        checked={infoFactu.attestation_verified}
                        value={infoFactu.attestation_verified}
                        disabled={infoFactu.attestation_verified && user.id_service !== 0}
                      />
                      <Typography variant="caption" sx={{ display: 'block', color: '#64748b', fontWeight: 600 }}>
                        {infoFactu.source_attestation_verified !== null
                          ? `${users.length !== 0 ? users.find((us) => us.id === infoFactu.source_attestation_verified).firstname : ''} ${users.length !== 0 ? users.find((us) => us.id === infoFactu.source_attestation_verified).lastname : ''} le ${moment(infoFactu.date_attestation_verified).format('DD/MM/YYYY HH:mm:ss')}`
                          : ''}
                      </Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow
                    sx={{
                      backgroundColor: 'white',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                      transition: 'transform 0.2s, box-shadow 0.2s',
                      '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' },
                    }}
                  >
                    <TableCell sx={{ borderBottom: 'none', borderRadius: '12px 0 0 12px' }}>
                      <Typography
                        variant="subtitle1"
                        sx={{ fontWeight: 700, color: '#334155' }}
                      >
                        Logs
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ borderBottom: 'none' }}>
                      <Switch
                        edge="end"
                        onClick={(event) => { setInfoFactu((prevState) => ({ ...prevState, logs_edited: !infoFactu.logs_edited })); changeFactuSession(event.target.checked, 'logs_edited'); }}
                        checked={infoFactu.logs_edited}
                        disabled={infoFactu.logs_edited && user.id_service !== 0}
                      />
                      <Typography variant="caption" sx={{ display: 'block', color: '#64748b', fontWeight: 600 }}>
                        {infoFactu.source_logs_edited !== null
                          ? `${users.length !== 0 ? users.find((us) => us.id === infoFactu.source_logs_edited).firstname : ''} ${users.length !== 0 ? users.find((us) => us.id === infoFactu.source_logs_edited).lastname : ''} le ${moment(infoFactu.date_logs_edited).format('DD/MM/YYYY HH:mm:ss')}`
                          : ''}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ borderBottom: 'none', borderRadius: '0 12px 12px 0' }}>
                      <Switch
                        edge="end"
                        onClick={(event) => { setInfoFactu((prevState) => ({ ...prevState, logs_verified: !infoFactu.logs_verified })); changeFactuSession(event.target.checked, 'logs_verified'); }}
                        checked={infoFactu.logs_verified}
                        disabled={infoFactu.logs_verified && user.id_service !== 0}
                      />
                      <Typography variant="caption" sx={{ display: 'block', color: '#64748b', fontWeight: 600 }}>
                        {infoFactu.source_logs_verified !== null
                          ? `${users.length !== 0 ? users.find((us) => us.id === infoFactu.source_logs_verified).firstname : ''} ${users.length !== 0 ? users.find((us) => us.id === infoFactu.source_logs_verified).lastname : ''} le ${moment(infoFactu.date_logs_verified).format('DD/MM/YYYY HH:mm:ss')}`
                          : ''}
                      </Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow
                    sx={{
                      backgroundColor: 'white',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                      transition: 'transform 0.2s, box-shadow 0.2s',
                      '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' },
                    }}
                  >
                    <TableCell sx={{ borderBottom: 'none', borderRadius: '12px 0 0 12px' }}>
                      <Typography
                        variant="subtitle1"
                        sx={{ fontWeight: 700, color: '#334155' }}
                      >
                        Traçabilité
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ borderBottom: 'none' }}>
                      <Switch
                        edge="end"
                        onClick={(event) => { setInfoFactu((prevState) => ({ ...prevState, traca_edited: !infoFactu.traca_edited })); changeFactuSession(event.target.checked, 'traca_edited'); }}
                        checked={infoFactu.traca_edited}
                        disabled={infoFactu.traca_edited && user.id_service !== 0}
                      />
                      <Typography variant="caption" sx={{ display: 'block', color: '#64748b', fontWeight: 600 }}>
                        {infoFactu.source_traca_edited !== null
                          ? `${users.length !== 0 ? users.find((us) => us.id === infoFactu.source_traca_edited).firstname : ''} ${users.length !== 0 ? users.find((us) => us.id === infoFactu.source_traca_edited).lastname : ''} le ${moment(infoFactu.date_traca_edited).format('DD/MM/YYYY HH:mm:ss')}`
                          : ''}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ borderBottom: 'none', borderRadius: '0 12px 12px 0' }}>
                      <Switch
                        edge="end"
                        onClick={(event) => { setInfoFactu((prevState) => ({ ...prevState, traca_verified: !infoFactu.traca_verified })); changeFactuSession(event.target.checked, 'traca_verified'); }}
                        checked={infoFactu.traca_verified}
                        value={infoFactu.traca_verified}
                        disabled={infoFactu.traca_verified && user.id_service !== 0}
                      />
                      <Typography variant="caption" sx={{ display: 'block', color: '#64748b', fontWeight: 600 }}>
                        {infoFactu.source_traca_verified !== null
                          ? `${users.length !== 0 ? users.find((us) => us.id === infoFactu.source_traca_verified).firstname : ''} ${users.length !== 0 ? users.find((us) => us.id === infoFactu.source_traca_verified).lastname : ''} le ${moment(infoFactu.date_traca_verified).format('DD/MM/YYYY HH:mm:ss')}`
                          : ''}
                      </Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow
                    sx={{
                      backgroundColor: 'white',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                      transition: 'transform 0.2s, box-shadow 0.2s',
                      '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' },
                    }}
                  >
                    <TableCell sx={{ borderBottom: 'none', borderRadius: '12px 0 0 12px' }}>
                      <Typography
                        variant="subtitle1"
                        sx={{ fontWeight: 700, color: '#334155' }}
                      >
                        Attestations sur honneur reçues ?
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ borderBottom: 'none' }}>
                      <Switch
                        edge="end"
                        onClick={(event) => { setInfoFactu((prevState) => ({ ...prevState, honneur_received: !infoFactu.honneur_received })); changeFactuSession(event.target.checked, 'honneur_received'); }}
                        checked={infoFactu.honneur_received}
                        disabled={!honneur || (infoFactu.honneur_received && user.id_service !== 0)}
                      />
                    </TableCell>
                    <TableCell sx={{ borderBottom: 'none', borderRadius: '0 12px 12px 0' }}>
                      <Typography variant="caption" sx={{ display: 'block', color: '#64748b', fontWeight: 600 }}>
                        {infoFactu.source_honneur_received !== null
                          ? `${users.length !== 0 ? users.find((us) => us.id === infoFactu.source_honneur_received).firstname : ''} ${users.length !== 0 ? users.find((us) => us.id === infoFactu.source_honneur_received).lastname : ''} le ${moment(infoFactu.date_honneur_received).format('DD/MM/YYYY HH:mm:ss')}`
                          : ''}
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
          </Card>
        </Grid>
        <Grid
          item
          md={5}
          xs={12}
        >
          <Card
            {...other}
            sx={{
              mt: 5,
              borderRadius: '20px',
              overflow: 'hidden',
              border: '1px solid #e2e8f0',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.07), 0 2px 4px -1px rgba(0, 0, 0, 0.04)',
              background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
            }}
          >
            <Box sx={{ p: 3, display: 'flex', alignItems: 'center', gap: 1.5, borderBottom: '1px solid #e2e8f0' }}>
              <Avatar sx={{ width: 44, height: 44, borderRadius: '14px', background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)', boxShadow: '0 6px 16px rgba(59, 130, 246, 0.35)' }}>
                <EventAvailableRoundedIcon sx={{ color: '#fff' }} />
              </Avatar>
              <Box>
                <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b' }}>Dates de facturation</Typography>
                <Typography variant="caption" sx={{ color: '#64748b' }}>Échéances et dates d&apos;envoi des documents</Typography>
              </Box>
            </Box>
            <Box
              sx={{ mt: 2, px: 2 }}
            >
              <Table sx={{ borderCollapse: 'separate', borderSpacing: '0 8px' }}>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ borderBottom: 'none', fontWeight: 800, color: '#64748b', textTransform: 'uppercase', fontSize: '0.72rem', letterSpacing: '0.04em' }}>
                      Type de document
                    </TableCell>
                    <TableCell sx={{ borderBottom: 'none', fontWeight: 800, color: '#64748b', textTransform: 'uppercase', fontSize: '0.72rem', letterSpacing: '0.04em' }}>
                      Date d&apos;envoi
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow
                    sx={{
                      backgroundColor: 'white',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                      transition: 'transform 0.2s, box-shadow 0.2s',
                      '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' },
                    }}
                  >
                    <TableCell sx={{ borderBottom: 'none', borderRadius: '12px 0 0 12px' }}>
                      <Typography
                        variant="subtitle1"
                        sx={{ fontWeight: 700, color: '#334155' }}
                      >
                        Facture
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ borderBottom: 'none', borderRadius: '0 12px 12px 0' }}>
                      <LocalizationProvider
                        dateAdapter={AdapterDayjs}
                        adapterLocale="fr"
                      >
                        <MobileDatePicker
                          label="Date d'édition"
                          inputFormat="DD/MM/yyyy"
                          onChange={() => null}
                          onClose={() => null}
                          showTodayButton
                          clearable
                          onAccept={(date) => { setInfoFactu((prevState) => ({ ...prevState, factu: date })); changeFactuSession(date !== null ? dayjs(date).format('YYYY-MM-DD') : null, 'factu'); }}
                          renderInput={(inputProps) => (
                            <TextField
                              {...inputProps}
                              InputProps={{ ...inputProps.InputProps, sx: { borderRadius: '12px', bgcolor: 'white' } }}
                            />
                          )}
                          value={infoFactu.factu ? dayjs(infoFactu.factu) : null}
                        />
                      </LocalizationProvider>
                      <Typography variant="caption" sx={{ display: 'block', color: '#64748b', fontWeight: 600, mt: 0.5 }}>
                        {infoFactu.source_factu !== null
                          ? `${users.length !== 0 ? users.find((us) => us.id === infoFactu.source_factu).firstname : ''} ${users.length !== 0 ? users.find((us) => us.id === infoFactu.source_factu).lastname : ''} le ${moment(infoFactu.date_factu).format('DD/MM/YYYY HH:mm:ss')}`
                          : ''}
                      </Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow
                    sx={{
                      backgroundColor: 'white',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                      transition: 'transform 0.2s, box-shadow 0.2s',
                      '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' },
                    }}
                  >
                    <TableCell sx={{ borderBottom: 'none', borderRadius: '12px 0 0 12px' }}>
                      <Typography
                        variant="subtitle1"
                        sx={{ fontWeight: 700, color: '#334155' }}
                      >
                        Demande de facturation ANDPC
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ borderBottom: 'none', borderRadius: '0 12px 12px 0' }}>
                    <LocalizationProvider
                        dateAdapter={AdapterDayjs}
                        adapterLocale="fr"
                      >
                        <MobileDatePicker
                          label="Date de facturation"
                          inputFormat="DD/MM/yyyy"
                          onChange={() => null}
                          onClose={() => null}
                          showTodayButton
                          clearable
                          onAccept={(date) => { setInfoFactu((prevState) => ({ ...prevState, demande_factu: date })); changeFactuSession(date !== null ? dayjs(date).format('YYYY-MM-DD') : null, 'demande_factu'); }}
                          renderInput={(inputProps) => (
                            <TextField
                              {...inputProps}
                              InputProps={{ ...inputProps.InputProps, sx: { borderRadius: '12px', bgcolor: 'white' } }}
                            />
                          )}
                          value={infoFactu.demande_factu ? dayjs(infoFactu.demande_factu) : null}
                        />
                      </LocalizationProvider>
                      <Typography variant="caption" sx={{ display: 'block', color: '#64748b', fontWeight: 600, mt: 0.5 }}>
                        {infoFactu.source_demande_factu !== null
                          ? `${users.length !== 0 ? users.find((us) => us.id === infoFactu.source_demande_factu).firstname : ''} ${users.length !== 0 ? users.find((us) => us.id === infoFactu.source_demande_factu).lastname : ''} le ${moment(infoFactu.date_demande_factu).format('DD/MM/YYYY HH:mm:ss')}`
                          : ''}
                      </Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow
                    sx={{
                      backgroundColor: 'white',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                      transition: 'transform 0.2s, box-shadow 0.2s',
                      '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' },
                    }}
                  >
                    <TableCell sx={{ borderBottom: 'none', borderRadius: '12px 0 0 12px' }}>
                      <Typography
                        variant="subtitle1"
                        sx={{ fontWeight: 700, color: '#334155' }}
                      >
                        Affacturage
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ borderBottom: 'none', borderRadius: '0 12px 12px 0' }}>
                    <LocalizationProvider
                        dateAdapter={AdapterDayjs}
                        adapterLocale="fr"
                      >
                        <MobileDatePicker
                          label="Date affacturage"
                          inputFormat="DD/MM/yyyy"
                          onChange={() => null}
                          onClose={() => null}
                          showTodayButton
                          clearable
                          onAccept={(date) => { setInfoFactu((prevState) => ({ ...prevState, affacturage: date })); changeFactuSession(date !== null ? dayjs(date).format('YYYY-MM-DD') : null, 'affacturage'); }}
                          renderInput={(inputProps) => (
                            <TextField
                              {...inputProps}
                              InputProps={{ ...inputProps.InputProps, sx: { borderRadius: '12px', bgcolor: 'white' } }}
                            />
                          )}
                          value={infoFactu.affacturage ? dayjs(infoFactu.affacturage) : null}
                        />
                      </LocalizationProvider>
                      <Typography variant="caption" sx={{ display: 'block', color: '#64748b', fontWeight: 600, mt: 0.5 }}>
                        {infoFactu.source_affacturage !== null
                          ? `${users.length !== 0 ? users.find((us) => us.id === infoFactu.source_affacturage).firstname : ''} ${users.length !== 0 ? users.find((us) => us.id === infoFactu.source_affacturage).lastname : ''} le ${moment(infoFactu.date_affacturage).format('DD/MM/YYYY HH:mm:ss')}`
                          : ''}
                      </Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow
                    sx={{
                      backgroundColor: 'white',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                      transition: 'transform 0.2s, box-shadow 0.2s',
                      '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' },
                    }}
                  >
                    <TableCell sx={{ borderBottom: 'none', borderRadius: '12px 0 0 12px' }}>
                      <Typography
                        variant="subtitle1"
                        sx={{ fontWeight: 700, color: '#334155' }}
                      >
                        Paiement ANDPC
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ borderBottom: 'none', borderRadius: '0 12px 12px 0' }}>
                      <LocalizationProvider
                        dateAdapter={AdapterDayjs}
                        adapterLocale="fr"
                      >
                        <MobileDatePicker
                          label="Date de paiement"
                          inputFormat="DD/MM/yyyy"
                          onChange={() => null}
                          onClose={() => null}
                          showTodayButton
                          clearable
                          onAccept={(date) => { setInfoFactu((prevState) => ({ ...prevState, paiement_andpc: date })); changeFactuSession(date !== null ? dayjs(date).format('YYYY-MM-DD') : null, 'paiement_andpc'); }}
                          renderInput={(inputProps) => (
                            <TextField
                              {...inputProps}
                              InputProps={{ ...inputProps.InputProps, sx: { borderRadius: '12px', bgcolor: 'white' } }}
                            />
                          )}
                          value={infoFactu.paiement_andpc ? dayjs(infoFactu.paiement_andpc) : null}
                        />
                      </LocalizationProvider>
                      <Typography variant="caption" sx={{ display: 'block', color: '#64748b', fontWeight: 600, mt: 0.5 }}>
                        {infoFactu.source_paiement_andpc !== null
                          ? `${users.length !== 0 ? users.find((us) => us.id === infoFactu.source_paiement_andpc).firstname : ''} ${users.length !== 0 ? users.find((us) => us.id === infoFactu.source_paiement_andpc).lastname : ''} le ${moment(infoFactu.date_paiement_andpc).format('DD/MM/YYYY HH:mm:ss')}`
                          : ''}
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
          </Card>
        </Grid>
      </Grid>
      {/* Dialog d'ajustement des coûts */}
      <Dialog
        open={openCostDialog}
        onClose={() => setOpenCostDialog(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{ sx: dialogPaperSx }}
      >
        <DialogTitle sx={{ fontWeight: 800, color: '#1e293b', pr: 6, position: 'relative' }}>
          Ajuster les coûts de la session
          <Typography variant="body2" sx={{ color: '#64748b', fontWeight: 500, mt: 0.5 }}>
            Saisissez les charges variables pour affiner le calcul de rentabilité
          </Typography>
          <IconButton
            onClick={() => setOpenCostDialog(false)}
            sx={{ position: 'absolute', top: 12, right: 12, color: 'text.secondary' }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ p: 3 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            {/* PRESTATION FORMATEUR */}
            <Box>
              <Typography variant="caption" sx={{ fontWeight: 800, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.08em', display: 'block', mb: 1.5 }}>
                Charges formateur — Prestation formateur
              </Typography>
              <Box sx={{ p: 2, bgcolor: '#fffbeb', borderRadius: '12px', border: '1px solid #ffe3a3', mb: 2 }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#b25e00', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <span>Prestation formateur</span>
                  <span>{costForm.trainer_rate_day * costForm.trainer_days} €</span>
                </Typography>
                <Typography variant="caption" sx={{ color: '#b25e00', fontWeight: 500, display: 'block', mt: 0.5 }}>
                  Modifiable depuis la fiche du formateur (tarif/jour) ou en surchargeant la session.( A Développer )
                </Typography>
              </Box>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Tarif journalier formateur"
                    type="number"
                    variant="outlined"
                    value={costForm.trainer_rate_day}
                    onChange={(e) => setCostForm({ ...costForm, trainer_rate_day: parseFloat(e.target.value) || 0 })}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">€</InputAdornment>,
                      sx: { borderRadius: '12px', bgcolor: 'white' }
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Nombre de jours formateur"
                    type="number"
                    variant="outlined"
                    value={costForm.trainer_days}
                    onChange={(e) => setCostForm({ ...costForm, trainer_days: parseFloat(e.target.value) || 0 })}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">j</InputAdornment>,
                      sx: { borderRadius: '12px', bgcolor: 'white' }
                    }}
                  />
                </Grid>
              </Grid>
            </Box>

            {/* CHARGES FORMATEUR */}
            <Box>
              <Typography variant="caption" sx={{ fontWeight: 800, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.08em', display: 'block', mb: 1.5 }}>
                Charges formateur — Frais annexes
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Frais de déplacement"
                    type="number"
                    variant="outlined"
                    value={costForm.frais_deplacement}
                    onChange={(e) => setCostForm({ ...costForm, frais_deplacement: parseFloat(e.target.value) || 0 })}
                    placeholder="Transport, taxi, péage..."
                    InputProps={{
                      endAdornment: <InputAdornment position="end">€</InputAdornment>,
                      sx: { borderRadius: '12px', bgcolor: 'white' }
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Frais d'hébergement"
                    type="number"
                    variant="outlined"
                    value={costForm.frais_hebergement}
                    onChange={(e) => setCostForm({ ...costForm, frais_hebergement: parseFloat(e.target.value) || 0 })}
                    placeholder="Nuit(s) hôtel"
                    InputProps={{
                      endAdornment: <InputAdornment position="end">€</InputAdornment>,
                      sx: { borderRadius: '12px', bgcolor: 'white' }
                    }}
                  />
                </Grid>
              </Grid>
            </Box>

            {/* LOGISTIQUE */}
            <Box>
              <Typography variant="caption" sx={{ fontWeight: 800, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.08em', display: 'block', mb: 1.5 }}>
                Logistique
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label={sessionData?.meeting_link ? "Salle (n/a virtuel)" : "Salle"}
                    type="number"
                    variant="outlined"
                    value={costForm.frais_salle}
                    onChange={(e) => setCostForm({ ...costForm, frais_salle: parseFloat(e.target.value) || 0 })}
                    disabled={!!sessionData?.meeting_link}
                    placeholder={sessionData?.meeting_link ? "Non applicable" : "Location salle..."}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">€</InputAdornment>,
                      sx: { borderRadius: '12px', bgcolor: 'white' }
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Autres charges (€)"
                    type="number"
                    variant="outlined"
                    value={costForm.autres_charges}
                    onChange={(e) => setCostForm({ ...costForm, autres_charges: parseFloat(e.target.value) || 0 })}
                    placeholder="Charges ponctuelles"
                    InputProps={{
                      endAdornment: <InputAdornment position="end">€</InputAdornment>,
                      sx: { borderRadius: '12px', bgcolor: 'white' }
                    }}
                  />
                </Grid>
              </Grid>
            </Box>

            {/* COÛTS PAR APPRENANT INSCRIT */}
            <Box>
              <Typography variant="caption" sx={{ fontWeight: 800, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.08em', display: 'block', mb: 1.5 }}>
                Coûts par apprenant inscrit ({count} actuellement)
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Restauration / apprenant"
                    type="number"
                    variant="outlined"
                    value={costForm.restauration_apprenant}
                    onChange={(e) => setCostForm({ ...costForm, restauration_apprenant: parseFloat(e.target.value) || 0 })}
                    helperText={`Total: ${count * costForm.restauration_apprenant} € • TTC, défaut 25 €`}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">€</InputAdornment>,
                      sx: { borderRadius: '12px', bgcolor: 'white' }
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Livret / apprenant"
                    type="number"
                    variant="outlined"
                    value={costForm.livret_apprenant}
                    onChange={(e) => setCostForm({ ...costForm, livret_apprenant: parseFloat(e.target.value) || 0 })}
                    helperText={`Total: ${count * costForm.livret_apprenant} € • TTC, défaut 6 €`}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">€</InputAdornment>,
                      sx: { borderRadius: '12px', bgcolor: 'white' }
                    }}
                  />
                </Grid>
              </Grid>
            </Box>

            {/* COMMISSION */}
            <Box>
              <Typography variant="caption" sx={{ fontWeight: 800, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.08em', display: 'block', mb: 1.5 }}>
                Commission
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Commission commerciale (%)"
                    type="number"
                    variant="outlined"
                    value={costForm.commission_commerciale}
                    onChange={(e) => setCostForm({ ...costForm, commission_commerciale: parseFloat(e.target.value) || 0 })}
                    helperText={`Soit ${Math.round(ca * (costForm.commission_commerciale / 100))} € sur un CA de ${Math.round(ca)} € • % du chiffre d'affaires TTC, défaut 25 %`}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">%</InputAdornment>,
                      sx: { borderRadius: '12px', bgcolor: 'white' }
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2.5, px: 3, justifyContent: 'space-between', bgcolor: '#f8fafc', borderTop: '1px solid #e2e8f0' }}>
          <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 700, color: '#334155' }}>
              Aperçu :
            </Typography>
            <Typography variant="h6" sx={{ fontWeight: 900, color: previewNetResult >= 0 ? '#0f5132' : '#991b1b' }}>
              {previewNetResult >= 0 ? '+' : ''}{Math.round(previewNetResult)} €
              <span style={{ fontSize: '0.85rem', fontWeight: 700, marginLeft: 6 }}>
                ({previewNetResult >= 0 ? '+' : ''}{Math.round(previewMargin)}%)
              </span>
            </Typography>
          </Box>
          
          <Box sx={{ display: 'flex', gap: 1.5 }}>
            <Button
              onClick={() => setOpenCostDialog(false)}
              variant="outlined"
              sx={{ borderRadius: '12px', textTransform: 'none', fontWeight: 700, px: 3 }}
            >
              Annuler
            </Button>
            <Button
              onClick={handleSaveCosts}
              variant="contained"
              disabled={isLoading}
              sx={{
                borderRadius: '12px',
                textTransform: 'none',
                fontWeight: 700,
                px: 3,
                bgcolor: '#2b221a',
                color: 'white',
                '&:hover': { bgcolor: '#1a1410' }
              }}
            >
              Enregistrer les coûts
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </motion.div>
  );
};

SessionFacturation.propTypes = {
  sessionId: PropTypes.number.isRequired,
  session: PropTypes.object.isRequired,
  formation: PropTypes.object.isRequired,
};

export default SessionFacturation;
